// frontend/admin-portal/src/routes/domains/dashboardRoutes.jsx
import React from "react";
import { Route } from "react-router-dom";
import Dashboard from "../../pages/Dashboard";

export default function DashboardRoutes() {
  return <Route index element={<Dashboard />} />;
}
